import Button from "@mui/material/Button";
import FutureBoardProgress from "./FutureBoardProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

type Translate = (key: string, options?: object) => string;

interface Props {
  open: boolean;
  busy: boolean;
  canSave: boolean;
  t: Translate;
  onSaveLeave: () => void;
  onDiscard: () => void;
  onKeep: () => void;
}

// 未保存のまま離れるときの確認。「編集を続ける」が既定（誤って内容を失わないように）。
function UnsavedChangesDialog({ open, busy, canSave, t, onSaveLeave, onDiscard, onKeep }: Props) {
  return (
    <Dialog open={open} onClose={busy ? undefined : onKeep} aria-labelledby="future-unsaved-title" maxWidth="xs" fullWidth>
      <DialogTitle id="future-unsaved-title">{t("futureBoard.unsaved.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("futureBoard.unsaved.body")}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", gap: 0.5 }}>
        <Button onClick={onKeep} disabled={busy} autoFocus variant="contained">
          {t("futureBoard.unsaved.keep")}
        </Button>
        <Button onClick={onSaveLeave} disabled={busy || !canSave}>
          {busy && <FutureBoardProgress size={18} />}{t("futureBoard.unsaved.saveLeave")}
        </Button>
        <Button onClick={onDiscard} disabled={busy} color="error">
          {t("futureBoard.unsaved.discard")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedChangesDialog;
